'use client';
import { isLoggedIn } from '@/app/funcs/api';
import Link from 'next/link';
import { useState } from 'react';

// named export
export const ContactForm = () => {

    const baseURL = process.env.NEXT_PUBLIC_BASE_URL;

    const [form, setForm] = useState({
        name: '',
        email: '',
        message: '',
        type: '',
        file: null
    });

    const [msg, setMsg] = useState('');
    const [sent, setSent] = useState('');
    const [submitting, setSubmitting] = useState(false);

    const handleFile = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith('image/')) {
            return setMsg('الملف يجب أن يكون صورة فقط');
        }
        if (file.size > 1024 * 1024) {
            return setMsg('الحد الأقصى لحجم الصورة 1 ميجابايت');
        }
        setForm({ ...form, file });
        setMsg('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setMsg('');

        try {
            let mediaId = null;

            // Step 1: Upload image to WP (if exists)
            if (form.file) {
                const imageData = new FormData();
                imageData.append('file', form.file);
                const uploadRes = await fetch(`${baseURL}api/wp/v2/media`, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`, // replace with real token
                    },
                    body: imageData
                });
                const imgJson = await uploadRes.json();
                mediaId = imgJson.id;
            }

            // Step 2: Submit contact message
            const res = await fetch(`${baseURL}api/ticket/v1/ticket`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}` // optional
                },
                body: JSON.stringify({
                    name: form.name,
                    message: form.message,
                    email: form.email,
                    type: form.type,
                    attachment: mediaId
                    // fields: {
                    //     email: form.email,
                    //     type: form.type,
                    //     attachment: mediaId
                    // }
                })
            });
            const data = await res.json().then((data) => {
                setMsg('تم إرسال الرسالة بنجاح')
                setSent(true);
            }).catch((err) => {
                console.error(err);
                setMsg('حدث خطأ أثناء الإرسال')
                setSent(false);
            });
    
        } catch (err) {
            setMsg('حدث خطأ أثناء الإرسال');
            setSent(false);
        }

        setSubmitting(false);
    };

    return (
        <div className="col-12 col-xl-8 mx-auto p-6 bg-white rounded-4 p-4  shadow-sm">
            <form onSubmit={handleSubmit} className="max-w-xl mx-auto p-4 space-y-4">
                <h1 className="text-xl font-bold">تواصل معنا</h1>

                {!isLoggedIn && (<p className='alert alert-info w-fit'>هل ترغب في إرفاق ملف ؟  <Link href='/login' className='btn btn-outline-dark ms-2'>تسجيل الدخول</Link> </p>)}
                <div className={`${msg ? 'd-none' : 'form-group my-3'}`}>
                    <label className="form-label mb-3">نوع الرسالة</label>
                    <div className="row mx-0 mb-4">
                        {['عام', 'اقتراح', 'شكوى', 'طلب انضمام لفريق فيجماوية', 'سؤال جديد'].map((type) => (
                            <div key={type} className="form-check col-auto">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="flexRadioDefault"
                                    id={`flexRadioDefault-${type}`}
                                    value={type}
                                    checked={form.type === type}
                                    onChange={(e) => setForm({ ...form, type: e.target.value })}
                                />
                                <label className="form-check-label" htmlFor={`flexRadioDefault-${type}`}>
                                    {type}
                                </label>
                            </div>
                        ))}
                    </div>
                    <input
                        type="text"
                        placeholder="الاسم"
                        required
                        value={form.name}
                        onChange={e => setForm({ ...form, name: e.target.value })}
                        className="form-control mb-4"
                        autoComplete='name'
                    />
                    <input
                        type="email"
                        placeholder="البريد الإلكتروني"
                        required
                        value={form.email}
                        onChange={e => setForm({ ...form, email: e.target.value })}
                        className="form-control rtl mb-4"
                        autoComplete='email'
                    />
                    <textarea
                        placeholder="رسالتك"
                        required
                        value={form.message}
                        onChange={e => setForm({ ...form, message: e.target.value })}
                        className="form-control mb-4"
                    />

                    {isLoggedIn && (
                       <>
                       <label for="file" className="form-label mb-3">أرفق ملف</label>
                        <input
                            id='file'
                            type="file"
                            accept="image/*"
                            onChange={handleFile}
                            className="form-control mb-4"
                        /></>
                    )}
                    <button
                        type="submit"
                        disabled={submitting}
                        className="btn btn-dark"
                    >
                        {submitting ? 'جاري الإرسال...' : 'إرسال'}
                    </button>
                </div>
                {msg && <div className={`alert ${sent ? 'alert-success' : 'alert-danger'}`}>{msg}</div>}
            </form>
        </div>
    );
}